import { render } from "./FormRecordOverview.vue?vue&type=template&id=30f2493e&scoped=true"
import script from "./FormRecordOverview.vue?vue&type=script&lang=js"
export * from "./FormRecordOverview.vue?vue&type=script&lang=js"

import "./FormRecordOverview.vue?vue&type=style&index=0&id=30f2493e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f2493e"]])

export default __exports__